import React, { useEffect, useRef } from "react";
import { Col, Container, Figure, Row, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { Remarkable } from "remarkable";
import { getStory, loadStories } from "../../../../controller/reducer/stories";
import { getLoading } from "../../../../controller/reducer/ui";

// const raw = `<font size="10"> A </font> few tips I would recommend others would be:
//   1. Keep in touch with one of your trusted family doctors as a measure of additional caution to ensure that you are taking proper care and steps to recover. Being in touch with them can give your morale a positive boost.
//   2. Make the checking of your Oxygen levels a part of your daily routine.
//   3. Isolate early using your common sense & follow doctors’ instruction early, without depending solely on the Covid test results to come in as it can take time.

// Over the course of my recovery, I discovered many noble initiatives online like [Yuva Volunteers](https://yuvavolunteers.org/), [CR21](https://cr21.ml/), etc.& kept following some of them for updates and help.
// `

const StoryItem = ({ match }) => {
  const story = useSelector(getStory);
  const dispatch = useDispatch();
  const md = useRef(
    new Remarkable("full", {
      linkTarget: "_blank",
      linkify: true,
      html: true,
      xhtmlOut: true,
      breaks: true,
      typographer: true,
      quotes: "“”‘’",
    })
  );

  useEffect(() => {
    dispatch(loadStories(match.params.id));
  }, [dispatch, match.params.id]);

  if (useSelector(getLoading))
    return (
      <Spinner
        style={{ position: "fixed", top: "50%", right: "47%" }}
        animation="border"
      />
    );

  return (
    <Container className=" p-4 bg-light" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>{`CR21 | ${story.name} Story`}</title>
        <meta name="description" content={story.desc} />
      </Helmet>
      <h1 className="h2 font-weight-normal ">
        {story.name} Covid Recovery Story
      </h1>
      <hr />
      <Row>
        <Col>
          <Figure
            className="img-story"
            style={{
              float: "left",
              margin: "25px",
              borderRadius: "50px",
            }}
          >
            <Figure.Image
              className="rounded-circle"
              src={
                story.image
                  ? story.image
                  : "https://culapp.co/static/media/notFound.914aef37.png"
              }
              alt="cover photo"
            />
            <Figure.Caption className="text-center">
              {story.desc}
            </Figure.Caption>
          </Figure>
          <br />
          <div
            className="font-weight-normal"
            style={{ display: "inline" }}
            dangerouslySetInnerHTML={{ __html: md.current.render(story.story) }}
            // dangerouslySetInnerHTML={{ __html: md.current.render(raw) }}
          ></div>
        </Col>
      </Row>
    </Container>
  );
};

export default StoryItem;
